import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import CommonService from "@/commons/services/CommonService";
import NationalHolidaysService, { NationalHolidaysGetModel } from "@/commons/services/NationalHolidays";
import LoginUser from "./LoginUser";

/** store state model */
export interface NationalHolidaysState {
  /** 祝日情報配列 */
  holidays: Array<NationalHolidaysGetModel>;
}

/**
 * ### NationalHolidays store
 *
 * - store
 *   - システム情報を保持する
 * - action, mutation
 *   - システム情報を設定する
 */
@Module({ name: "nationalHolidays" })
export default class NationalHolidays extends VuexModule implements NationalHolidaysState {
  holidays: Array<NationalHolidaysGetModel> = [];

  @Mutation
  private SET_HOLIDAYS(holidays: Array<NationalHolidaysGetModel>): void {
    this.holidays = holidays;
    return;
  }

  @Action({ rawError: true })
  public async init(payload: { userStore: LoginUser }): Promise<void> {
    try {
      const commonService: CommonService = new CommonService();
      const sationalHolidaysService: NationalHolidaysService = new NationalHolidaysService(commonService);
      const response: Array<NationalHolidaysGetModel> = await sationalHolidaysService.gets(payload.userStore);

      // 休日は振替休日のことなので、通称である「振替休日」に置換する
      const holidays: Array<NationalHolidaysGetModel> = [];
      for (const day of response) {
        if (day.name == "休日") {
          day.name = "振替休日";
        }
        holidays.push(day);
      }
      this.SET_HOLIDAYS(holidays);

      return;
    } catch (error) {
      console.error(error);
    }
  }
}
